<script>
import {
  trainerComputed,
  trainerMethods,
  authMethods,
  adminPanelComputed,
  adminPanelMethods,
  clientMethods,
  authComputed,
  organizationComputed,
} from '@state/helpers';
import cloneDeep from 'lodash/cloneDeep';
import has from 'lodash/has';
import moment from 'moment';

export default {
  props: {
    isInvited: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRegistered: {
      type: Boolean,
      required: false,
      default: false,
    },
    client: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      selectedPricePlan: null,
      isLoading: false,
    };
  },
  computed: {
    ...adminPanelComputed,
    ...trainerComputed,
    ...authComputed,
    ...organizationComputed,
    trainerProductPricing() {
      let productPricing = [];
      if (
        this.currentUser.roles.isTrainer &&
        this.currentUser.trainer.myProducts.length > 0 &&
        this.currentUser.trainer.myProducts[0].plans &&
        this.currentUser.trainer.myProducts[0].plans.length > 0
      ) {
        productPricing = this.currentUser.trainer.myProducts[0].plans.map(
          (plan) => {
            return {
              label: plan.nickname + ' - $' + plan.unit_amount / 100,
              ...plan,
            };
          }
        );
      }
      return productPricing;
    },
    currentSub() {
      let plan = '';
      let planId = '';
      if (this.client) {
        planId =
          this.client && this.client.invitation
            ? this.client.invitation.price_plan
            : '';
      }

      if (
        this.currentUser.roles.isTrainer &&
        this.currentUser.trainer.myProducts &&
        this.currentUser.trainer.myProducts.length > 0 &&
        this.currentUser.trainer.myProducts[0].plans &&
        this.currentUser.trainer.myProducts[0].plans.length > 0
      ) {
        plan = this.currentUser.trainer.myProducts[0].plans.find(
          (plan) => plan.id === planId
        );
      }
      if (plan) {
        return {
          label: plan.nickname + ' - $' + plan.unit_amount / 100,
          ...plan,
        };
      }
      return plan;
    },
    noPlanSelected() {
      return (
        (this.selectedPricePlan === undefined ||
          this.selectedPricePlan === null) &&
        (this.currentSub === undefined || this.currentSub === null)
      );
    },
  },
  methods: {
    ...adminPanelMethods,
    ...trainerMethods,
    ...authMethods,
    ...clientMethods,
    async sendInvoice() {
      this.isLoading = true;
      const client = cloneDeep(this.client);
      const currentSubId = this.selectedPricePlan
        ? this.selectedPricePlan.id
        : this.currentSub.id;
      const invitePayload = {
        client_id: client._id,
        trainer_id: client.trainer_id,
      };

      let updatePayload = {};
      if (
        (this.client &&
          this.client.invitation &&
          has(this.client.invitation, 'price_plan') &&
          !this.client.invitation.price_plan) ||
        !has(this.client.invitation, 'price_plan')
      ) {
        updatePayload = {
          ...client,
          invitation: { ...client.invitation, price_plan: currentSubId },
          profile: { ...client.profile, subscribed: false },
        };
      } else {
        if (
          client &&
          client.profile &&
          has(client.profile, 'subscribed_plan') &&
          client.profile.subscribed_plan &&
          has(client.profile, 'start_date') &&
          client.profile.start_date &&
          has(client.profile, 'end_date') &&
          client.profile.end_date &&
          has(client.profile, 'subscribed') &&
          client.profile.subscribed &&
          !moment(client.profile.end_date).before()
        ) {
          updatePayload = {
            ...client,
            profile: { ...client.profile, subscribed_plan: currentSubId },
          };
        } else {
          updatePayload = {
            ...client,
            profile: {
              ...client.profile,
              subscribed_plan: currentSubId,
              subscribed: false,
            },
          };
        }
      }
      delete updatePayload.hasUnreadMessages;

      this.updateClient({ clientObj: updatePayload })
        .then(async (res) => {
          if (res.client) {
            if (!this.isRegistered && !this.isInvited) {
              try {
                await this.inviteClient({ inviteObj: invitePayload }).then(
                  async (data) => {
                    if (data && data.success) {
                      const clientEmail = this.client.email;
                      const trainerEmail = this.trainerEmail;
                      window.clevertap.event.push('Invite Client', {
                        client: clientEmail,
                        trainer: trainerEmail,
                        app: 'Tandem',
                      });
                    }
                  }
                );
              } catch (e) {
                console.log('Faild sending invoice');
              }
            }
            try {
              const updatedClient = await this.getClient({
                clientObj: res.client,
              });
              await this.setUpdateClientItem(updatedClient);
              await this.setSelectedClient(updatedClient);
            } catch (e) {
              console.log('Faild Getting client');
            }
            this.setHideAdminPanel();
            this.isLoading = false;
          }
        })
        .catch((e) => console.log('Error Updating client'));
    },
    setPricePlan(val) {
      this.selectedPricePlan = val;
    },
  },
};
</script>

<template>
  <div class="account-details-container">
    <div class="row">
      <div class="col-9"
        ><label>product name</label>
        <v-select
          :options="trainerProductPricing"
          :searchable="false"
          :clearable="false"
          placeholder="Select Subscription"
          :value="selectedPricePlan ? selectedPricePlan : currentSub"
          @input="setPricePlan"
        />
        <p v-if="!isInvited && !isRegistered"
          >{{ client.profile.firstName }} hasn’t been invited yet. Sending an
          invoice will also send an invite to the
          {{ organizationTitle }} app.</p
        >
        <p v-show="trainerProductPricing.length === 0"
          >To enable {{ organizationTitle }} PAY for this client.
          <router-link to="/products">Please add a product</router-link></p
        >
        <BaseButton
          class="btn-secondary btn-round"
          @click="sendInvoice"
          :disabled="noPlanSelected || trainerProductPricing.length === 0"
        >
          <span v-if="!isLoading">Send Invoice</span>
          <BaseIcon v-if="isLoading" name="sync" spin />
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

::v-deep .vs__search {
  padding-bottom: 3px;
}

.account-details-container {
  margin-left: 1rem;
  margin-top: 2rem;
  p {
    color: $color-danger;
    margin-bottom: 1rem;
  }
  .button {
    height: 4rem;
    min-width: 16rem;
    &:disabled {
      opacity: 0.5;
      &:hover {
        background-color: white;
        color: $color-action;
      }
    }
  }
}
</style>
